import { ContextualMenu, IconButton, IContextualMenuItem } from "@fluentui/react";
import React, { PropsWithChildren, useEffect, useRef } from "react";
import { useStyles } from "./ProviderButtonMenu.styles";

export const ProviderButtonMenu: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const [isMenuHidden, setMenuHidden] = React.useState(true);
  const ref = useRef<HTMLDivElement>(null);
  const parentRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (ref.current) {
      parentRef.current = ref.current.parentElement;
    }
  }, []);

  const menuItems: IContextualMenuItem[] =
    React.Children.toArray(children)
      .filter(child => child !== null)
      .map((child, index) => ({
        key: `${index}`,
        data: child,
      }));

  const hasMenuItems = menuItems.length > 0;
  const styles = useStyles(hasMenuItems);

  return (
    <div ref={ref} className={styles.providerButtonMenu}>
      <div className={styles.splitter} />
      <IconButton
        className={styles.splitButton}
        iconProps={{ iconName: 'ChevronDown', styles: { root: { fontSize: 12 } } }}
        onClick={(event) => {
          event.stopPropagation();
          setMenuHidden(!isMenuHidden);
        }}
      />
      {hasMenuItems && (
        <ContextualMenu
          beakWidth={0}
          styles={{
            root: { width: `${parentRef.current?.clientWidth}px` },
          }}
          items={menuItems}
          hidden={isMenuHidden}
          onDismiss={() => setMenuHidden(true)}
          useTargetAsMinWidth={true}
          useTargetWidth={true}
          onItemClick={() => setMenuHidden(true)}
          target={parentRef}
          onRenderContextualMenuItem={(item) => item?.data}
        />
      )}
    </div>
  )
}
